import { makeStyles, shorthands } from '@fluentui/react-components';

export const useVideoPageStyle = makeStyles({
  videoPage: {
    display: 'flex',
    ...shorthands.margin('32px', '36px'),
    flexDirection: 'column',
    ...shorthands.gap('24px'),
    ...shorthands.overflow('hidden'),
  },
});
